import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, from, switchMap, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { ConfigService } from '../services/config.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly authService: AuthService,
    private readonly configService: ConfigService,
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.isTokenRequest(req.url) || req.url.includes('/assets/config.json')) {
      return next.handle(req);
    }

    return from(this.authService.refreshIfNeeded()).pipe(
      switchMap(() => {
        const token = this.authService.getAccessToken();
        const request = token
          ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
          : req;

        return next.handle(request).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401 && token) {
              this.authService.logout(false);
            }

            return throwError(() => error);
          }),
        );
      }),
    );
  }

  private isTokenRequest(url: string): boolean {
    const tokenUrl = this.configService.resolveKeycloakTokenUrl();

    return (
      url.startsWith(tokenUrl) ||
      url.startsWith('/realms/') ||
      url.startsWith('/auth/realms/') ||
      url.includes('/protocol/openid-connect/token')
    );
  }
}
